export const NEW_PASSWORD = "newPassword";
export const CONFIRM_PASSWORD = "confirmPassword";
export const CURRENT_PASSWORD = "oldPassword";
